import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.checkOrientation();
    window.addEventListener("resize", this.checkOrientation);
  }

  disconnect() {
    window.removeEventListener("resize", this.checkOrientation);
  }

  checkOrientation = () => {
    const rotateMessage = document.getElementById("rotate-message");

    if (window.innerWidth < 768 && window.innerHeight > window.innerWidth) {
      // Mostra a mensagem se estiver no modo portrait em dispositivos móveis
      rotateMessage.classList.remove("d-none");
    } else {
      // Esconde a mensagem se estiver no modo landscape ou em telas grandes
      rotateMessage.classList.add("d-none");
    }
  }
}
